export default {
	inputTitle: "Электронная почта",
	modal: {
		title: "Подписаться",
		details: "Читай каждую неделю наши письма и прокачивай свои скиллы!",
		action: "Поехали!",
		successTitle: "Отлично!",
		successDetails: "Спасибо что подписались",
		successAction: "Хорошо",
	},
}
